export default {
    slug: 'marketing',
    ability: 'marketing',
    routes: [
        // Contact Lists
        {
            path: 'marketing/lists',
            name: 'contactlist-list',
            component: () => import('@modules/Marketing/Resources/js/pages/lists/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'contactlist-preview',
                    component: () => import('@modules/Marketing/Resources/js/pages/lists/Preview.vue'),
                    redirect: { name: 'contactlist-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/marketing/lists/:id(\\d+)',
                            name: 'contactlist-overview',
                            component: () => import('@modules/Marketing/Resources/js/pages/lists/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'members',
                            name: 'contactlist-members',
                            component: () => import('@modules/Marketing/Resources/js/pages/lists/preview/Members.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Campaigns
        {
            path: 'marketing/campaigns',
            name: 'campaign-list',
            component: () => import('@modules/Marketing/Resources/js/pages/campaigns/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'campaign-preview',
                    component: () => import('@modules/Marketing/Resources/js/pages/campaigns/Preview.vue'),
                    redirect: { name: 'campaign-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/marketing/campaigns/:id(\\d+)',
                            name: 'campaign-overview',
                            component: () =>
                                import('@modules/Marketing/Resources/js/pages/campaigns/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'analytics',
                            name: 'campaign-analytics',
                            component: () =>
                                import('@modules/Marketing/Resources/js/pages/campaigns/preview/Analytics.vue'),
                            props: true
                        },
                        {
                            path: 'recipients',
                            name: 'campaign-recipients',
                            component: () =>
                                import('@modules/Marketing/Resources/js/pages/campaigns/preview/Recipients.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'campaign-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'campaign-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Campaign Templates
        {
            path: 'marketing/templates',
            name: 'campaign-template-list',
            component: () => import('@modules/Marketing/Resources/js/pages/templates/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'campaign-template-preview',
                    component: () => import('@modules/Marketing/Resources/js/pages/templates/Preview.vue'),
                    redirect: { name: 'campaign-template-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/marketing/templates/:id(\\d+)',
                            name: 'campaign-template-overview',
                            component: () =>
                                import('@modules/Marketing/Resources/js/pages/templates/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'activities',
                            name: 'campaign-template-activities',
                            component: () => import('@/components/base/tabs/TabActivities.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Campaign Editor (full page)
        {
            path: 'marketing/campaigns/new',
            name: 'campaign-new',
            component: () => import('@modules/Marketing/Resources/js/pages/campaigns/Editor.vue')
        },
        {
            path: 'marketing/campaigns/:id(\\d+)/edit',
            name: 'campaign-edit',
            component: () => import('@modules/Marketing/Resources/js/pages/campaigns/Editor.vue'),
            props: route => ({ id: route.params.id })
        }
    ],
    nav: () => ({
        section: 'marketing',
        items: [
            {
                title: i18n.t('Campaigns'),
                icon: 'email-multiple-outline',
                to: { name: 'campaign-list' }
            },
            {
                title: i18n.t('Contact Lists'),
                icon: 'account-group-outline',
                to: { name: 'contactlist-list' }
            },
            {
                title: i18n.t('Templates'),
                icon: 'file-document-edit-outline',
                to: { name: 'campaign-template-list' }
            }
        ]
    })
};
